import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

import {
  FormGroup,
  Row,
  Col,
  ControlLabel,
} from 'react-bootstrap';


import OperatorFilter from '../../../fields/OperatorFilter';
import LeaseForm from './LeaseForm';

const propTypes = exact({
  onHide: PropTypes.func.isRequired,
});


class FormWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      operator: null,
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(operator) {
    this.setState({ operator });
  }

  render() {
    const { operator } = this.state;
    const operatorId = (operator) ? operator.id : null;
    return (
      <div>
        <Row>
          <Col xs={12}>
            <ControlLabel>Select an Operator</ControlLabel>
            <FormGroup>
              <OperatorFilter
                name="Operator"
                noneOption={false}
                onChange={this.onChange}
              />
            </FormGroup>
          </Col>
        </Row>
        {operatorId && (
        <LeaseForm
          joinType="lookup_records"
          lookupStatus="reference"
          operatorId={operatorId}
          onHide={this.props.onHide}
        />
        )}
      </div>
    );
  }
}

FormWrapper.propTypes = propTypes;

export default FormWrapper;
